import { createStore, createHook, StoreActionApi } from "react-sweet-state";

/** Một mục breadcrumb tuỳ biến. href = null/undefined → hiển thị tĩnh, không điều hướng. */
export type BreadcrumbItem = {
  title: string;
  href?: string | null;
  /** Màu chữ tuỳ biến (áp cho mục cuối/hiện tại). Bỏ trống → dùng màu mặc định. */
  color?: string;
};

export type BreadcrumbState = { items: BreadcrumbItem[] | null };

export const BREADCRUMB_STORE = "BreadcrumbStore";
type StoreApi = StoreActionApi<BreadcrumbState>;

const initialState: BreadcrumbState = { items: null };

const actions = {
  /** Đặt breadcrumb tuỳ biến cho trang hiện tại (override breadcrumb sinh theo route). */
  setBreadcrumb:
    (items: BreadcrumbItem[]) =>
    ({ setState }: StoreApi) => {
      setState({ items });
    },
  /** Xoá breadcrumb tuỳ biến — quay về breadcrumb mặc định theo route. */
  clearBreadcrumb:
    () =>
    ({ setState }: StoreApi) => {
      setState({ items: null });
    },
};

export type BreadcrumbActions = typeof actions;

export const StoreBreadcrumb = createStore<BreadcrumbState, BreadcrumbActions>({
  initialState,
  actions,
  name: BREADCRUMB_STORE,
});

const useBreadcrumb = createHook(StoreBreadcrumb);

export default useBreadcrumb;
